import { useTranslation } from 'react-i18next';
import { X, Trash2 } from 'lucide-react';
import clx from 'classnames';
import Modal from '../Modal';
import useWindowSize from 'utils/useWindowSize';
import styles from './ConfirmSecondaryModal.module.scss';

const ConfirmSecondaryModal = ({
  isModalOpen,
  setIsModalOpen,
  title,
  subtitle,
  content,
  action,
  Icon,
  buttons = [],
  width = '400px',
  buttonsActions = [],
  showDismiss = true,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();
  const btns = buttons.length
    ? buttons
    : [t('common.actions.cancel'), t('common.actions.disable')];

  const close = () => setIsModalOpen(false);

  const runAction = (index) => {
    const handler = buttonsActions[index] || action;
    if (typeof handler === 'function') handler();
  };

  return (
    <Modal
      width={isMobile ? '100%' : width}
      maxWidth={isMobile ? 'calc(100vw - 32px)' : width}
      height="auto"
      maxHeight="fit-content"
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      centered
      borderRadius="16px"
    >
      <div
        className={clx(styles.panel, {
          [styles.panel_mobile]: isMobile,
        })}
      >
        <button type="button" className={styles.close_btn} onClick={close} aria-label={t('common.actions.close')}>
          <X size={18} strokeWidth={2.4} aria-hidden />
        </button>

        <div className={styles.hero}>
          <div className={styles.icon_wrap} aria-hidden>
            {Icon ? <Icon /> : <Trash2 size={22} strokeWidth={2.3} />}
          </div>
          {title ? <h2 className={styles.title}>{title}</h2> : null}
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </div>

        {content ? <div className={styles.content}>{content}</div> : null}

        <div className={styles.actions}>
          {btns.map((label, index) => {
            const isPrimary = index === 0;
            return (
              <button
                key={`${label}-${index}`}
                type="button"
                className={clx(styles.btn, {
                  [styles.btn_danger]: isPrimary,
                  [styles.btn_danger_soft]: !isPrimary,
                })}
                onClick={() => runAction(index)}
              >
                {label}
              </button>
            );
          })}
          {showDismiss ? (
            <button type="button" className={clx(styles.btn, styles.btn_ghost)} onClick={close}>
              {t('common.actions.cancel')}
            </button>
          ) : null}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmSecondaryModal;
